export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '4fc90fbc-1fdc-4601-ab9e-7ce64701a341';
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const MODAL_CLOSE_SECONDS = 1.3;

//Forkify API: https://forkify-api.herokuapp.com/v2
